import { useState } from 'react'
import { useEffect } from 'react'
import { useAppSelector } from 'src/hooks'
import { selectTerm } from 'src/redux/definition/definition.selector'
import { ModalCommon } from '..'
import { Dictionary } from './components/Dictionary/Dictionary'

export const DictionaryModal = ({ visible, onClose }) => {
	const term = useAppSelector(selectTerm)
	const [editWord, setEditWord] = useState(term)

	useEffect(() => {
		setEditWord(term)
	}, [term])

	return (
		<ModalCommon visible={visible} handleCancel={onClose} width="70%">
			<Dictionary editWord={editWord} />
		</ModalCommon>
	)
}
